import React, {ReactNode, useMemo, useRef} from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter} from "@pg-design/helpers-css";

interface IProps {
    isActive: boolean;
    children: (params: {isVisible: boolean}) => ReactNode;
}

export const ReelSliderSlide = (props: IProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const slideMainWrapper = useMemo(() => ref.current?.closest(".slick-slide"), [ref.current]);
    const isVisible = Boolean(slideMainWrapper?.classList.contains("slick-active"));

    const childrenMemorized = useMemo(() => props.children({isVisible}), [isVisible]);

    return (
        <div ref={ref} css={reelDetailWrapperStyle}>
            {isVisible ? props.children({isVisible}) : childrenMemorized}
        </div>
    );
};

const reelDetailWrapperStyle = css`
    display: inline-flex !important; // override slick-slider display: inline-block
    ${flexAbsoluteCenter};
    width: 100vw;
    height: 100vh;
    height: 100dvh;
`;
import React, {ReactNode, useMemo, useRef} from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter} from "@pg-design/helpers-css";

interface IProps {
    isActive: boolean;
    children: (params: {isVisible: boolean}) => ReactNode;
}

export const ReelSliderSlide = (props: IProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const slideMainWrapper = useMemo(() => ref.current?.closest(".slick-slide"), [ref.current]);
    const isVisible = Boolean(slideMainWrapper?.classList.contains("slick-active"));

    const childrenMemorized = useMemo(() => props.children({isVisible}), [isVisible]);

    return (
        <div ref={ref} css={reelDetailWrapperStyle}>
            {isVisible ? props.children({isVisible}) : childrenMemorized}
        </div>
    );
};

const reelDetailWrapperStyle = css`
    display: inline-flex !important; // override slick-slider display: inline-block
    ${flexAbsoluteCenter};
    width: 100vw;
    height: 100vh;
    height: 100dvh;
`;
